import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useWaitForTransactionReceipt, type UseWaitForTransactionReceiptReturnType } from 'wagmi';
import { useSafeTxHashTransformer } from './useSafeTxHashTransformer';
import type { UseWaitForTransactionReceiptParameters } from 'wagmi';
import type { Hash } from 'viem';
export const useSafeWaitForTransactionReceipt = args => {
  const $ = _c(7);
  const [transformedHash, setTransformedHash] = useState(args.hash);
  const transformHash = useSafeTxHashTransformer();
  let t0;
  let t1;
  if ($[0] !== args.hash || $[1] !== transformHash) {
    t0 = () => {
      const transform = async () => {
        const newHash = await transformHash(args.hash);
        setTransformedHash(newHash);
      };
      transform();
    };
    t1 = [args.hash, transformHash];
    $[0] = args.hash;
    $[1] = transformHash;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  const t2 = transformedHash as Hash;
  let t3;
  if ($[4] !== args || $[5] !== t2) {
    t3 = {
      ...args,
      hash: t2
    };
    $[4] = args;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const result = useWaitForTransactionReceipt(t3);
  return result;
};